import { render, staticRenderFns } from "./CustomerPortalWrapper.vue?vue&type=template&id=caf8118c&scoped=true&"
import script from "./CustomerPortalWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPortalWrapper.vue?vue&type=style&index=0&id=caf8118c&prod&scoped=true&lang=css&"
import style1 from "./CustomerPortalWrapper.vue?vue&type=style&index=1&id=caf8118c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf8118c",
  null
  
)

export default component.exports